// eslint-disable-next-line import/no-unresolved
import { set } from '@/utils/vuex';

const mutations = {
  assessmentsWithClients: set('assessmentsWithClients'),
  reportMetrics: set('reportMetrics'),
  currentAssessment: set('currentAssessment'),
};
export default mutations;
